import script from "./BillingDataPaid.PlanInfo.Annual.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingDataPaid.PlanInfo.Annual.vue?vue&type=script&setup=true&lang=ts"

import "./BillingDataPaid.PlanInfo.Annual.vue?vue&type=style&index=0&id=5185679f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5185679f"]])

export default __exports__